import React from 'react';
import { ThemeProvider } from '@niaratech/ota-components/src';
import { useSelector } from './app/index';
export default function ThemeProviderOtaBuilderForm(props: React.PropsWithChildren<any>): JSX.Element {
  const theme = useSelector(r => r.theme.theme);
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
}